import { Component, ElementRef, Injector } from '@angular/core';
import { BaseResourceFormComponent, DepreciacaoImovelItem, Imovel, ImovelOcorrencia, LoginContabil, ReavaliacaoImovelItem } from 'eddydata-lib';
import { takeUntil } from 'rxjs/operators';
import { DepreciacaoImovelItemService } from 'projects/patrimonio/src/app/depreciacao-imovel/service/depreciacao-imovel-item.service';
import { ReavaliacaoImovelItemService } from 'projects/patrimonio/src/app/reavaliacao-imovel/service/reavaliacao-imovel-item.service';
import { BemImovelService } from '../service/bem-imovel.service';

@Component({
  selector: 'app-bem-imovel-view',
  templateUrl: './bem-imovel-view.component.html'
})
export class BemImovelViewComponent extends BaseResourceFormComponent<Imovel, LoginContabil> {

  /**
   * Declaração de variáveis
   */
  readOnly: boolean;
  public ocorrencias: ImovelOcorrencia[] = [];
  public listaDepreciacao: DepreciacaoImovelItem[] = [];
  public listaReavaliacao: ReavaliacaoImovelItem[] = [];

  /**
   * Construtor com as injeções de dependencias
   */
  constructor(
    protected injector: Injector,
    protected depreciacaoImovelItemService: DepreciacaoImovelItemService,
    protected reavaliacaoImovelItemService: ReavaliacaoImovelItemService,
    protected bemImovelService: BemImovelService) {
    super(new Imovel(), injector, Imovel.converteJson, bemImovelService);
    this.readOnly = true;
  }

  // ========================================================================
  //                        MÉTODOS ABSTRAÍDOS
  // ========================================================================

  protected criarCamposForm(): void {

  }

  protected parametrosExtras(): {} {
    return { relations: 'setor.unidade,responsavel' };
  }

  protected afterLoad() {
    this.depreciacaoImovelItemService.filtrar(0, 0, {
      'imovel_id': this.entidade.id, 'depreciacao.pendente': false, status: 'DEPRECIADO', 'depreciacao.orgao.id': this.login.orgao.id, relations: 'depreciacao.usuario',
      orderBy: 'depreciacao.ano$DESC,depreciacao.mes$DESC,depreciacao.data_cadastro$DESC'
    }).pipe(takeUntil(this.unsubscribe))
      .subscribe(res => this.listaDepreciacao = res.content);

    this.reavaliacaoImovelItemService.filtrar(0, 0, {
      'imovel_id': this.entidade.id, 'reavaliacao.encerrado': true, 'reavaliacao.orgao.id': this.login.orgao.id, relations: 'reavaliacao.usuario',
      orderBy: 'reavaliacao.data_efetivacao$DESC'
    }).pipe(takeUntil(this.unsubscribe))
      .subscribe(res => this.listaReavaliacao = res.content);
  }

  protected afterInit(): void {
  }

  protected campoFoco(): ElementRef {
    return null;
  }

  protected beforeSubmit() {
  }

  protected afterSubmit(modelo: Imovel) {
  }

  // ========================================================================
  //                            MÉTODOS DA CLASSE
  // ========================================================================

}
